import { render } from "./NewsfeedCards.vue?vue&type=template&id=4b0ec920&scoped=true"
import script from "./NewsfeedCards.vue?vue&type=script&lang=js"
export * from "./NewsfeedCards.vue?vue&type=script&lang=js"

import "./NewsfeedCards.vue?vue&type=style&index=0&id=4b0ec920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0ec920"]])

export default __exports__